// extracted by mini-css-extract-plugin
module.exports = {"container":"donations_container__2aG29","mainContainer":"donations_mainContainer__16qXF","tableContent":"donations_tableContent__ETgR6","buttons":"donations_buttons__uteop"};